import { useKeycloak } from "@react-keycloak/web";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";

import { IconDownloadCloud02, IconBookOpen02 } from "@pentabd/icons";
import { Button, Header } from "@pentabd/ui";

import { downloadManpowerReport } from "@api/manPowerReports";

export const ManpowerPageHeader = () => {
  const { t } = useTranslation();
  let location = useLocation();
  const { keycloak } = useKeycloak();
  const token = keycloak.token as string;

  const breadcrumbs = [
    {
      icon: <IconBookOpen02 size="20" />,
    },
    {
      label: t("REPORTS.MANPOWER_REPORTS.HEADER"),
    },
  ];

  const headerText = {
    header: t("REPORTS.MANPOWER_REPORTS.HEADER"),
  };

  const handleDownload = async () => {
    try {
      if (location.search) {
        let params = new URLSearchParams(location.search);
        let queries: any = {};
        params.forEach((value, key) => {
          queries[key] = value;
        });

        const res = await downloadManpowerReport(
          // positionId,
          token,
          t("REPORTS.MANPOWER_REPORTS.HEADER"),
          {
            ...queries,
          },
        );
      }
    } catch (error) {}
  };

  return (
    <Header
      breadcrumbs={breadcrumbs}
      headerText={headerText}
      actions={
        location.search
          ? [
              <Button type="primary" size="sm" onClick={handleDownload}>
                <IconDownloadCloud02 size="16" fill="white" />
                {t("REPORTS.DOWNLOAD_BTN")}
              </Button>,
            ]
          : undefined
      }
    />
  );
};
